import { render, staticRenderFns } from "./StaticPage.vue?vue&type=template&id=eb1d6dca"
import script from "./StaticPage.vue?vue&type=script&lang=js"
export * from "./StaticPage.vue?vue&type=script&lang=js"
import style0 from "./StaticPage.vue?vue&type=style&index=0&id=eb1d6dca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports